"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M14.152 13.518h.893v-.016a.472.472 0 0 1 0 .938H14.04a11.513 11.513 0 0 1-1.815 5.25 8.664 8.664 0 0 0 1.89-.69.479.479 0 1 1 .42.863 9.75 9.75 0 0 1-4.185 1.02h-.172a9.75 9.75 0 1 1 0-19.5h.142a9.698 9.698 0 0 1 9.473 8.152.458.458 0 0 1-.383.54.465.465 0 0 1-.54-.382 8.106 8.106 0 0 0-.218-.96h-4.5c.075.765.113 1.56.113 2.392 0 .832-.038 1.643-.113 2.393Zm-.944 0a23.968 23.968 0 0 0 0-4.785H7.32a24.01 24.01 0 0 0-.128 2.392c.003.8.045 1.598.128 2.393h5.887ZM10.297 2.32h-.053c-1.11.023-2.31 2.153-2.805 5.475h5.647c-.495-3.307-1.687-5.43-2.79-5.475Zm3.742 5.475h4.29a8.753 8.753 0 0 0-6.097-5.25 11.604 11.604 0 0 1 1.807 5.25ZM6.487 7.75A11.535 11.535 0 0 1 8.325 2.5a8.835 8.835 0 0 0-6.3 5.25h4.462Zm-.112.968H1.702a8.648 8.648 0 0 0 0 4.784h4.673a24.42 24.42 0 0 1-.12-2.392c0-.832.045-1.642.12-2.392Zm.112 5.722H2.025v.015a8.835 8.835 0 0 0 6.3 5.235 11.535 11.535 0 0 1-1.838-5.25Zm3.75 5.475h.075v.015c1.103-.067 2.28-2.183 2.776-5.49H7.44c.495 3.322 1.695 5.475 2.798 5.475Zm12.398-4.552h.187a1.05 1.05 0 0 1 1.065 1.05v4.627a1.043 1.043 0 0 1-1.042 1.043h-5.903A1.043 1.043 0 0 1 15.9 21.04v-4.627a1.05 1.05 0 0 1 1.042-1.05h.188V13.96a2.752 2.752 0 0 1 5.505 0v1.402Zm-4.051-2.679c-.34.34-.532.802-.532 1.284l-.007 1.395h3.637v-1.396a1.815 1.815 0 0 0-3.098-1.283Zm4.313 8.43c.02-.02.03-.046.03-.074v-4.627a.112.112 0 0 0-.105-.113H16.92a.113.113 0 0 0-.105.113v4.627a.104.104 0 0 0 .105.105h5.902a.105.105 0 0 0 .075-.03Z",
    clipRule: "evenodd"
  })]
});